import { Box } from '@mui/system';
import type { FormSelectOption } from 'components/ui/form/GenericForm/index.js';
import {
  type Control,
  Controller,
  type FieldValues,
} from 'react-hook-form';

import type { AutocompleteProps } from '../Autocomplete/index.js';
import { Autocomplete } from '../Autocomplete/index.js';

interface Props<FormValues extends FieldValues = any> {
  field: AutocompleteProps['field'];
  control: Control<FormValues>;
  transform?: {
    value: (value: unknown) => unknown; onChange: (value: string | number | (string | number)[]) => unknown;
  };
}

export const FormAutocomplete = ({ control, field, transform }: Props) => {
  return (
    <Controller
      key={`${field.name}`}
      name={field.name}
      control={control}
      render={({ field: { value: originalValue, onChange } }) => {
        const fieldOptions = field.options;

        if (!fieldOptions) {
          throw new Error('field.options is required');
        }

        const mappedOriginalValue = originalValue && (transform ? transform.value(originalValue) : originalValue);
        const value = field.componentProps?.multiple
          ? (mappedOriginalValue ?? []).map((value: string) => fieldOptions.find(opt => opt.value === value))
          : fieldOptions.find(opt => opt.value === mappedOriginalValue);

        return (
          <Box
            minHeight={50}
            display="flex"
            flexDirection="column"
            justifyContent="flex-end"
          >
            <Autocomplete
              field={field}
              onChange={(_e, option) => {
                if (field.componentProps?.multiple) {
                  const value = (option as FormSelectOption[]).map(opt => opt.value);
                  onChange(transform ? transform.onChange(value) : value);
                } else {
                  const value = (option as FormSelectOption)?.value ?? '';
                  onChange(transform ? transform.onChange(value) : value);
                }
              }}
              value={value}
            />
          </Box>
        );
      }}
    />
  );
};
